import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { faCloudArrowUp } from '@fortawesome/pro-light-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { mergeMap } from 'rxjs/operators';
import { IFileDocument } from '../../models/interfaces/files.interface';
import { FilesService } from '../../services/files.service';
import { GeneratorsUtility } from '../../utilities/generators';

@Component({
  selector: 'hcr-files-drop-zone',
  templateUrl: './files-drop-zone.component.html',
  styleUrls: ['./files-drop-zone.component.sass'],
})
export class FilesDropZoneComponent implements OnInit {
  @Output() startUploading = new EventEmitter<IFileDocument>();
  @Output() endUploading = new EventEmitter<{ file: IFileDocument; temporaryId: string }>();

  public fileUploadForm: FormGroup;

  public icons = {
    cloudArrowUp: faCloudArrowUp,
  };

  public states = {
    dragOver: false,
  };

  @HostListener('document:dragover', ['$event'])
  public dragOverListener(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.states.dragOver = true;
  }

  @HostListener('document:dragleave', ['$event'])
  public dragLeaveListener(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();

    if (event['target']['className'] === 'drop-zone-area') {
      this.states.dragOver = false;
    }
  }

  @HostListener('document:drop', ['$event'])
  public dropListener(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.states.dragOver = false;

    if (event.dataTransfer.files.length > 0) {

      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        this.uploadFile(event.dataTransfer.files[i]);
      }
    } else if (event.dataTransfer.getData('text')) {
      event.dataTransfer
        .getData('text')
        .split(',')
        .forEach((fileId) => {
          if (new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$', 'i').test(fileId)) {
            this.getFromFileId(fileId);
          }
        });
    }
  }

  constructor(private _formBuilder: FormBuilder, private _filesService: FilesService, private _toastr: ToastrService) {
    this.fileUploadForm = this._formBuilder.group({
      file: new FormControl('', [Validators.required]),
      fileSource: new FormControl('', [Validators.required]),
    });
  }

  public getFromFileId(fileId: string): void {
    this.startUploading.emit({
      _temporary: true,
      id: fileId,
      contentType: '',
      fileExtension: '',
      fileType: '',
      fileURI: '',
      name: '',
      size: 0,
    });

    this._filesService.getFile(fileId).subscribe(
      (newfile) => {
        this.endUploading.emit({
          file: {
            _temporary: false,
            id: newfile.id,
            contentType: newfile.fileType,
            fileExtension: newfile.fileExtension,
            fileType: '',
            fileURI: '',
            name: newfile.name,
            size: newfile.size,
          },
          temporaryId: newfile.id,
        });
      },
      (error) => {
        if (error.error.message) {
          this._toastr.error(`Erro ao enviar arquivo: ${error.error.message}`);
        } else {
          this._toastr.error('Erro ao enviar arquivo');
        }
      }
    );
  }

  public uploadFile(file: File): void {
    const temporaryId = GeneratorsUtility.generateGUID();

    this.startUploading.emit({
      _temporary: true,
      id: temporaryId,
      contentType: file.type,
      fileExtension: file.name.split('.').pop(),
      fileType: '',
      fileURI: '',
      name: file.name,
      size: file.size,
    });

    this.fileUploadForm.patchValue({
      fileSource: file,
    });

    const formData = new FormData();
    formData.append('file', <Blob>this.fileUploadForm.get('fileSource').value);
    this._filesService
      .uploadFile(formData)
      .pipe(
        mergeMap((response) => {
          return this._filesService.getFile(response.id);
        })
      )
      .subscribe(
        (newfile) => {
          this.endUploading.emit({
            file: {
              _temporary: false,
              id: newfile.id,
              contentType: newfile.fileType,
              fileExtension: newfile.fileExtension,
              fileType: '',
              fileURI: '',
              name: newfile.name,
              size: newfile.size,
            },
            temporaryId,
          });
        },
        (error) => {
          if (error.error.message) {
            this._toastr.error(`Erro ao enviar arquivo: ${error.error.message}`);
          } else {
            this._toastr.error('Erro ao enviar arquivo');
          }
        }
      );
  }

  ngOnInit(): void {
    document.createAttribute('draggable');
  }
}
